export enum MetadataPutEnum {
  DELETADO = "DELETADO",
  CRIADO = "CRIADO",
  ALTERADO = "ALTERADO",
  INALTERADO = "INALTERADO"
}